export const AMEND_APPOINTMENT_TITLE = 'Amend appointment';

export const ANALYTICS_APPT_MODAL = 'amend appt model';
export const ANALYTICS_APPT_CLOSE = 'amend appt:Close';
export const ANALYTICS_APPT_MODAL_CLOSE = 'amend appt confirmation:Close';
export const AMENDS_CONFIRMATION_TITLE = 'Please review new appointment details';
export const AMENDS_CONFIRMATION_SUBTITLE = 'We’ll make the changes as soon as we can. Please note: while we’re doing this, you can’t make any further changes to your appointment.';
export const AMEND_LIVE_CHAT ='Contact us on Live Chat';
export const AMEND_LIVE_CHAT_DESCRIPTION ='Because you’re changing your Engineer Visit, you’ll need a new Expert Setup too. Please contact us in Live Chat to discuss the change.';
export const AMEND_LIVE_CHAT_HEADING ='Reschedule Expert Setup';